import { Trans, useTranslation } from 'react-i18next';

export const Footer = () => {
  const { t } = useTranslation();

  return (
    <ul className="text-b2xl lg:text-2xl md:text-L-basic px-2 md:px-0 text-L-primary-50 list-disc">

      <li className="my-2 text-right w-full">
        {t(`BrokerCode_${window.api?.BROKER_CODE}.Terms1`)}
      </li>

      <ul className='grid 2xl:grid-cols-[38%_62%] whitespace-nowrap gap-2 list-disc'>

        <li>
          {t(`BrokerCode_${window.api?.BROKER_CODE}.Terms4`)}
        </li>

        <li>
          {t(`BrokerCode_${window.api?.BROKER_CODE}.Terms3`)}
        </li>

        <li>
          {t(`BrokerCode_${window.api?.BROKER_CODE}.Terms2`)}
        </li>

        <li>
          <Trans
            i18nKey={`BrokerCode_${window.api?.BROKER_CODE}.Terms0`}
            values={{ n: window.location.origin, interpolation: { escapeValue: false } }}
            components={[
              <a
                href={window.location.origin}
                className="dir-ltr text-L-info-100 d-inline-block"
              >
                NotFound
              </a>,
            ]}
          />
        </li>

      </ul>

    </ul>
  );
};
